// import React from 'react'
// import img1 from '../../assets/img1.jpg';
// import img2 from '../../assets/img2.jpg';
// import img3 from '../../assets/img3.jpg';
// import img4 from '../../assets/img4.jpg';
// import './style.css';

// const ImageSlider = () => {
//     //step 1: get DOM
// let nextDom = document.getElementById('next');
// let prevDom = document.getElementById('prev');

// let carouselDom = document.querySelector('.carousel');
// let SliderDom = carouselDom.querySelector('.carousel .list');
// let thumbnailBorderDom = document.querySelector('.carousel .thumbnail');
// let thumbnailItemsDom = thumbnailBorderDom.querySelectorAll('.item');
// let timeDom = document.querySelector('.carousel .time');

// thumbnailBorderDom.appendChild(thumbnailItemsDom[0]);
// let timeRunning = 3000;
// let timeAutoNext = 7000;

// nextDom.onclick = function(){
//     showSlider('next');    
// }

// prevDom.onclick = function(){
//     showSlider('prev');    
// }
// let runTimeOut;
// // let runNextAuto = setTimeout(() => {
// //     next.click();
// // }, timeAutoNext)
// function showSlider(type){
//     let  SliderItemsDom = SliderDom.querySelectorAll('.carousel .list .item');
//     let thumbnailItemsDom = document.querySelectorAll('.carousel .thumbnail .item');
    
//     if(type === 'next'){
//         SliderDom.appendChild(SliderItemsDom[0]);
//         thumbnailBorderDom.appendChild(thumbnailItemsDom[0]);
//         carouselDom.classList.add('next');
//     }else{
//         SliderDom.prepend(SliderItemsDom[SliderItemsDom.length - 1]);
//         thumbnailBorderDom.prepend(thumbnailItemsDom[thumbnailItemsDom.length - 1]);
//         carouselDom.classList.add('prev');
//     }
//     clearTimeout(runTimeOut);
//     runTimeOut = setTimeout(() => {
//         carouselDom.classList.remove('next');
//         carouselDom.classList.remove('prev');
//     }, timeRunning);

//     // clearTimeout(runNextAuto);
//     // runNextAuto = setTimeout(() => {
//     //     next.click();
//     // }, timeAutoNext)
// }
//   return (
//     <div>
//          <div class="carousel">
//         {/* <!-- list item --> */}
//         <div class="list">
//             <div class="item">
//                 <img src={img1} />
//                 <div class="content">
//                     <div class="author">LUNDEV</div>
//                     <div class="title">DESIGN SLIDER</div>
//                     <div class="topic">ANIMAL</div>
//                     <div class="des">
//                         {/* <!-- lorem 50 --> */}
//                         Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ut sequi, rem magnam nesciunt minima placeat, itaque eum neque officiis unde, eaque optio ratione aliquid assumenda facere ab et quasi ducimus aut doloribus non numquam. Explicabo, laboriosam nisi reprehenderit tempora at laborum natus unde. Ut, exercitationem eum aperiam illo illum laudantium?
//                     </div>
//                     <div class="buttons">
//                         <button>SEE MORE</button>
//                         <button>SUBSCRIBE</button>
//                     </div>
//                 </div>
//             </div>
//             <div class="item">
//                 <img src={img2} />
//                 <div class="content">
//                     <div class="author">LUNDEV</div>
//                     <div class="title">DESIGN SLIDER</div>
//                     <div class="topic">ANIMAL</div>
//                     <div class="des">
//                         Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ut sequi, rem magnam nesciunt minima placeat, itaque eum neque officiis unde, eaque optio ratione aliquid assumenda facere ab et quasi ducimus aut doloribus non numquam. Explicabo, laboriosam nisi reprehenderit tempora at laborum natus unde. Ut, exercitationem eum aperiam illo illum laudantium?
//                     </div>
//                     <div class="buttons">
//                         <button>SEE MORE</button>
//                         <button>SUBSCRIBE</button>
//                     </div>
//                 </div>
//             </div>
//             <div class="item">
//                 <img src={img3}/>
//                 <div class="content">
//                     <div class="author">LUNDEV</div>
//                     <div class="title">DESIGN SLIDER</div>
//                     <div class="topic">ANIMAL</div>
//                     <div class="des">
//                         Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ut sequi, rem magnam nesciunt minima placeat, itaque eum neque officiis unde, eaque optio ratione aliquid assumenda facere ab et quasi ducimus aut doloribus non numquam. Explicabo, laboriosam nisi reprehenderit tempora at laborum natus unde. Ut, exercitationem eum aperiam illo illum laudantium?
//                     </div>
//                     <div class="buttons">
//                         <button>SEE MORE</button>
//                         <button>SUBSCRIBE</button>
//                     </div>
//                 </div>
//             </div>
//             <div class="item">
//                 <img src={img4}/>
//                 <div class="content">
//                     <div class="author">LUNDEV</div>
//                     <div class="title">DESIGN SLIDER</div>
//                     <div class="topic">ANIMAL</div>
//                     <div class="des">
//                         Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ut sequi, rem magnam nesciunt minima placeat, itaque eum neque officiis unde, eaque optio ratione aliquid assumenda facere ab et quasi ducimus aut doloribus non numquam. Explicabo, laboriosam nisi reprehenderit tempora at laborum natus unde. Ut, exercitationem eum aperiam illo illum laudantium?
//                     </div>
//                     <div class="buttons">
//                         <button>SEE MORE</button>
//                         <button>SUBSCRIBE</button>
//                     </div>
//                 </div>
//             </div>
//         </div>
//         {/* <!-- list thumnail --> */}
//         <div class="thumbnail">
//             <div class="item">
//                 <img src={img1}/>
//                 <div class="content">
//                     <div class="title">
//                         Name Slider
//                     </div>
//                     <div class="description">
//                         Description
//                     </div>
//                 </div>
//             </div>
//             <div class="item">
//                 <img src={img2}/>
//                 <div class="content">
//                     <div class="title">
//                         Name Slider
//                     </div>
//                     <div class="description">
//                         Description
//                     </div>
//                 </div>
//             </div>
//             <div class="item">
//                 <img src={img3}/>
//                 <div class="content">
//                     <div class="title">
//                         Name Slider
//                     </div>
//                     <div class="description">
//                         Description
//                     </div>
//                 </div>
//             </div>
//             <div class="item">
//                 <img src={img4}/>
//                 <div class="content">
//                     <div class="title">
//                         Name Slider
//                     </div>
//                     <div class="description">
//                         Description
//                     </div>
//                 </div>
//             </div>
//         </div>
//         {/* <!-- next prev --> */}

//         <div class="arrows">
//             <button id="prev"> {'<'} </button>
//             <button id="next"> {'>'} </button>
//         </div>
//         {/* <!-- time running --> */}
//         <div class="time"></div>
//     </div>
//     </div>
//   )
// }

// export default ImageSlider

import React, { useEffect, useRef, useCallback } from 'react';
import './Carousel.css'; // Include your styles
import img1 from '../../assets/img1.jpg';
import img2 from '../../assets/img2.jpg';
import img3 from '../../assets/img3.jpg';
import img4 from '../../assets/img4.jpg';
import img5 from '../../assets/img5.jpg';
import img6 from '../../assets/img6.jpg';

const Carousel = () => {
  const carouselRef = useRef(null);
  const listRef = useRef(null);
  const thumbnailRef = useRef(null);
  const nextRef = useRef(null);
  const prevRef = useRef(null);
  const timeRef = useRef(null);
  const images = [img6,img3,img5,img4];
  const timeRunning = 3000;
  const timeAutoNext = 7000;
  const runTimeOut = useRef(null);
  const runNextAuto = useRef(null);

  const showSlider = useCallback((type) => {
    const sliderItems = listRef.current.querySelectorAll('.item');
    const thumbnailItems = thumbnailRef.current.querySelectorAll('.item');

    if (type === 'next') {
      listRef.current.appendChild(sliderItems[0]);
      thumbnailRef.current.appendChild(thumbnailItems[0]);
      carouselRef.current.classList.add('next');
    } else {
      listRef.current.prepend(sliderItems[sliderItems.length - 1]);
      thumbnailRef.current.prepend(thumbnailItems[thumbnailItems.length - 1]);
      carouselRef.current.classList.add('prev');
    }

    clearTimeout(runTimeOut.current);
    runTimeOut.current = setTimeout(() => {
      carouselRef.current.classList.remove('next');
      carouselRef.current.classList.remove('prev');
    }, timeRunning);

    clearTimeout(runNextAuto.current);
    runNextAuto.current = setTimeout(() => {
      nextRef.current.click();
    }, timeAutoNext);
  }, []);

  useEffect(() => {
    const thumbnails = thumbnailRef.current.querySelectorAll('.item');
    if (thumbnails.length > 0) {
      thumbnailRef.current.appendChild(thumbnails[0]);
    }

    nextRef.current.addEventListener('click', () => showSlider('next'));
    prevRef.current.addEventListener('click', () => showSlider('prev'));

    runNextAuto.current = setTimeout(() => {
      nextRef.current.click();
    }, timeAutoNext);

    return () => {
      clearTimeout(runTimeOut.current);
      clearTimeout(runNextAuto.current);
    };
  }, [showSlider]);

  return (
    <div className='bodyLayout'>
    <div className="carousel" ref={carouselRef}>
      <div className="list" ref={listRef}>
        {images.map((img,i) => (
          <div className="item" key={i}>
            <img src={img} alt={`Slide ${i}`} />
            <div className="content">
              <div className="author">Your travel partner</div>
              <div className="title">WANDER DISCOVER REPEAT</div>
              <div className="topic">Pravasa.In</div>
              <div className="des">
              Your trusted partner for unforgettable journeys. Discover hidden gems and explore the world with ease...
              </div>
              <div className="buttons">
                <button>SEE MORE</button>
                <button>SUBSCRIBE</button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="thumbnail" ref={thumbnailRef}>
        {images.map((img,i) => (
          <div className="item" key={`thumb-${i}`}>
            <img src={img} alt={`Thumbnail ${i}`} />
            <div className="content">
              {/* <div className="title">Name Slider</div>
              <div className="description">Description</div> */}
            </div>
          </div>
        ))}
      </div>

      <div className="arrows">
        <button id="prev" ref={prevRef}>&lt;</button>
        <button id="next" ref={nextRef}>&gt;</button>
      </div>

      <div className="time" ref={timeRef}></div>
    </div>
    </div>
  );
};

export default Carousel;
